import ListMasterConceptGroup from './views/List.vue'
import CreateEditMasterConceptGroup from './views/CreateEdit.vue'
import GetMasterConceptGroup from './views/Get.vue'

export const MasterConceptGroupRoutes = [
  {
    path: '/master-concept-groups',
    name: 'ListMasterConceptGroups',
    component: ListMasterConceptGroup,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'concept_group:list'
    }
  },
  {
    path: '/master-concept-group',
    name: 'CreateMasterConceptGroup',
    component: CreateEditMasterConceptGroup,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'concept_group:create'
    }
  },
  {
    path: '/master-concept-group/:id',
    name: 'UpdateMasterConceptGroup',
    component: CreateEditMasterConceptGroup,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'concept_group:update'
    }
  },
  {
    path: '/master-concept-group/view/:id',
    name: 'GetMasterConceptGroup',
    component: GetMasterConceptGroup,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'concept_group:list'
    }
  }
]
